import React from 'react';
import { Grid, List, ListItemText } from '@material-ui/core';
import {
  noDashboardH1, noDashboardH1L1, noDashboardH1L2, noDashboardH1L3, noDashboardH2, supportAtos,
} from '../../constants/Constants';
import useStyles from '../style';

const NoDashboard = () => {
  const classes = useStyles();
  return (
    <Grid item xs={12} sm={12} md={10} className={classes.noDasboardGrid}>
      <ul>
        <li>
          <h4>
            <span>{noDashboardH1}</span>
          </h4>
        </li>
        <List className={classes.noDasboardList}>
          <ListItemText primary={noDashboardH1L1} />
          <ListItemText primary={noDashboardH1L2} />
          <ListItemText primary={noDashboardH1L3} />
        </List>
        <li>
          <h4>
            {noDashboardH2}
            <span className={classes.atos}>
              {supportAtos}
            </span>
          </h4>
        </li>
      </ul>
    </Grid>
  );
};

export default NoDashboard;
